import Body from "./Body";
import BodyParagraph from "./BodyParagraph";
import BodyEmphasized from "./BodyEmphasized";
import BodyStrong from "./BodyStrong";
import BodyFade from "./BodyFade";

export default Body;
export { BodyEmphasized, BodyStrong, BodyFade, BodyParagraph };
